import {
  toLocaleStringOptions,
} from '../config';

const formatDate = (date, lang, format = toLocaleStringOptions.basic) => (
  new Date(date).toLocaleDateString(lang, format)
);

export default formatDate;
